import { WINDOW } from '../constants.js';
import { createPerformanceSpans } from './createPerformanceSpans.js';

/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */
function addMemoryEntry(replay) {
  // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
  try {
    createPerformanceSpans(replay, [
      // @ts-ignore memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
      createMemoryEntry(WINDOW.performance.memory),
    ]);
  } catch (error) {
    // Do nothing
  }
}

export { addMemoryEntry };
//# sourceMappingURL=addMemoryEntry.js.map
